<template>
  <div id="ReceiptExportPdf">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 px-5 mt-1">
      <div class="header d-flex justify-space-between align-center">
        <h1 class="px-0">Exportações de Canhotos em PDF</h1>
      </div>

      <div class="d-flex my-5">
        <v-icon class="pr-1">mdi-information-outline</v-icon>
        <div class="info-message">Atenção, apenas os últimos 5 registros serão mantidos.</div>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="receiptsPdf"
          :loading="isLoading"
          :footer-props="{
            'items-per-page-options': [],
            itemsPerPageText: '100'
          }"
          disable-pagination
          no-data-text="Nenhum resultado encontrado"
        >
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ transformDate(item.createdAt) }}
          </template>

          <template v-slot:[`item.actions`]="{ item, index }">
            <div>
              <template v-if="isDownloadLoading && index === loadingIndexItem">
                <div>
                  <v-progress-circular indeterminate color="secondary" size="20" width="3"></v-progress-circular>
                </div>
              </template>
              <v-tooltip top v-else>
                <template #activator="{ on, attrs }">
                  <v-icon
                    :disabled="isAvaliableToDownload(item.status)"
                    :class="{ 'download-disabled': isAvaliableToDownload(item.status) }"
                    @click="onDownloadClick(item.id, index)"
                    v-on="on"
                    v-bind="attrs"
                    >mdi-download</v-icon
                  >
                </template>
                Baixar
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="d-flex align-center py-3">
          <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="7"></v-pagination>
          <reload-button @click="getAllReceiptsPdfList()" />
        </div>
      </div>
    </v-card>
    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import { mapActions } from 'vuex';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import MessagesError from '@/components/MessagesError.vue';
import ReloadButton from '@/components/ReloadButton';
export default {
  name: 'ReceiptsPdf',
  components: {
    MessagesError,
    BreadCrumb,
    ReloadButton
  },
  data: () => ({
    isInitialDateMenuOpen: false,
    isEndDateMenuOpen: false,
    initialDate: null,
    endDate: null,
    receiptsPdf: [],
    isLoading: false,
    isDownloadLoading: false,
    loadingIndexItem: null,
    totalPages: 1,
    pageNumber: 1,
    pageSize: 10,
    errors: [],
    errorsType: 'error',
    headers: [
      { text: 'DATA DE SOLICITAÇÃO', value: 'createdAt', align: 'start' },
      { text: 'ID DA FATURA', value: 'numberInvoiceId' },
      { text: 'EXPORTADO POR', value: 'userName' },
      { text: 'STATUS', value: 'status' },
      { text: 'AÇÕES', value: 'actions', sortable: false }
    ],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Exportações',
        disabled: true
      },
      {
        text: 'Canhotos em PDF',
        disabled: true,
        to: '/receipts-export-pdf'
      }
    ]
  }),

  computed: {
    formattedDate() {
      if (!this.initialDate) return '';
      const [year, month, day] = this.initialDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  created() {
    this.getAllReceiptsPdfList();
    this.handleFeedback();
  },

  methods: {
    ...mapActions('ShippersStore', ['getReceiptsPdfList', 'downloadReceiptPdf']),
    async getAllReceiptsPdfList() {
      try {
        this.isLoading = true;
        const data = await this.getReceiptsPdfList();
        this.receiptsPdf = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async onDownloadClick(pdfId, index) {
      try {
        this.isDownloadLoading = true;
        this.loadingIndexItem = index;
        const data = await this.downloadReceiptPdf(pdfId);
        if (data.success) this.onFeedbackReceive({ errorsType: 'success', message: 'Download realizado com sucesso!' });
      } catch (error) {
        console.error(error);
        this.onFeedbackReceive({ errorsType: 'error', message: 'Não foi possível realizar download.' });
      } finally {
        this.loadingIndexItem = null;
        this.isDownloadLoading = false;
      }
    },

    isAvaliableToDownload(statusName) {
      if (statusName.toLowerCase() === 'processando') {
        return true;
      }
      return false;
    },

    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },
    transformNfes(nfes) {
      return nfes.join(', ');
    },
    transformDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },
    onFeedbackReceive({ errorsType, message }) {
      this.errorsType = errorsType;
      this.errors = [message];
      this.setClearErrorTimer();
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
.download-disabled {
  opacity: $button-disabled-opacity;
}
</style>
